const handleDropdownExpand = () => {
  const $dropdownElements = document.querySelectorAll<HTMLDivElement>('[data-lang-dropdown]')
  $dropdownElements.forEach(($dropdownElement) => {
    $dropdownElement.hidden = !$dropdownElement.hidden
  })
}

export default function initLangSwitcher(): void {
  const $langSwitcherElements = document.querySelectorAll<HTMLDivElement>('[data-lang-switcher]')
  $langSwitcherElements.forEach(($singleLangSwitcher) => {
    $singleLangSwitcher.addEventListener('click', handleDropdownExpand)
  })
}
